export let splash = {
	start: function(){
		let count = 0;
		let $cover = document.querySelector("#cover");
		let $lists = document.querySelectorAll("#splash_content li");
		let max = $lists.length;
		return new Promise((resolve, reject) =>{
			next();
			function next(){
				
				//console.log(count);
				let $current = $lists[count];
				for(let i = 0; i < $lists.length; i++){
					$lists[i].classList.remove("active");
				}
				$current.classList.add("active");
				count++;
				if(count >= max){
					setTimeout(function(){
						resolve();
					}, 3000);
				}else{
					let duration = 100;
					if(count === 1){
						duration = 1000;
					}
					
					setTimeout(function(){
						/*if(count === 10){
							return false
						}else{
							
						}*/
						next();
					}, duration);
				}
			}
		});
		//console.log("splash start");
	}
}